<template>
  <div id="app" class="uk-position-relative uk-container">
    <router-view />
    <Footer class="uk-position-absolute uk-position-bottom-center uk-margin">
      <span slot="footerText" class="uk-text-muted"
        >Developed by
        <a
          class="uk-text-primary uk-text-muted uk-text-italic"
          href="https://bouziweb.com/"
          target="_blank"
          >Achraf GAOUBOUZI</a
        ></span
      >
    </Footer>
  </div>
</template>
<script>
import UIkit from "uikit";
import Footer from "@/components/footer";
import Icons from "uikit/dist/js/uikit-icons";
import Vue from "vue";

UIkit.use(Icons);

export default Vue.extend({
  name: "App",
});
</script>

<style lang="scss">
@import "../node_modules/uikit/src/scss/variables.scss";
@import "../node_modules/uikit/src/scss/mixins.scss";
@import "../node_modules/uikit/src/scss/uikit.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
</style>
